const extraPrechatFormDetails = [
  {
    label: 'First Name',
    transcriptFields: ['Customer_First_Name__c'],
  },
  {
    label: 'Last Name',
    transcriptFields: ['Customer_Last_Name__c'],
  },
  {
    label: 'Phone',
    transcriptFields: ['Customer_Phone_Number__c'],
  },
  {
    label: 'Email',
    transcriptFields: ['Email__c'],
  },
  {
    label: 'Subject',
    transcriptFields: ['Chat_Subject__c'],
  },
];

function initESW(gslbBaseURL) {
  window.embedded_svc.settings.displayHelpButton = true;
  window.embedded_svc.settings.language = 'en-US';
  window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
  window.embedded_svc.settings.entryFeature = 'LiveAgent';
  // .backgroundImg appears below .embeddedservice-chatheader_chatheader header
  // window.embedded_svc.settings.prechatBackgroundImgURL = '/images/Pre-Chat-Banner.jpg';
  // .embeddedservice-chatheader_chat header appears next to "Contact Us" in .sidebarHeader
  // and next to text in .minimizedImage chat window
  window.embedded_svc.settings.smallCompanyLogoImgURL = '/images/TD-Logo.svg';
  // .waitingImage appears when chat is loading below "Hello, <name>!"
  // window.embedded_svc.settings.waitingStateBackgroundImgURL = '/images/Waiting-State.png';
  // appears next to agent/bot name in chat window
  window.embedded_svc.settings.avatarImgURL = '/images/Agent-Avatar-Bear.jpg';
  window.embedded_svc.settings.chatbotAvatarImgURL = '/images/Agent-Avatar-Bear.jpg';
  window.embedded_svc.settings.extraPrechatFormDetails = extraPrechatFormDetails;
  window.embedded_svc.init(
    'https://tirediscounters.my.salesforce.com',
    'https://tirediscounters.secure.force.com/liveAgentSetupFlow',
    gslbBaseURL,
    '00Df2000000Cdrz',
    'Global_Chat',
    {
      baseLiveAgentContentURL:
        'https://c.la4-c2-phx.salesforceliveagent.com/content',
      deploymentId: '572f2000000Ts8V',
      buttonId: '573f2000000Tsms',
      baseLiveAgentURL: 'https://d.la4-c2-phx.salesforceliveagent.com/chat',
      eswLiveAgentDevName: 'Global_Chat',
      isOfflineSupportEnabled: true,
    },
  );
}

function initializeButton() {
  if (!window.embedded_svc) {
    const s = document.createElement('script');
    s.setAttribute(
      'src',
      'https://tirediscounters.my.salesforce.com/embeddedservice/5.0/esw.min.js',
    );
    s.onload = () => {
      initESW(null);
    };
    document.body.appendChild(s);
  } else {
    initESW('https://service.force.com');
  }

  document.querySelector('a[href="#liveChat"]')?.addEventListener('click', (e) => {
    e.preventDefault();
    window.embedded_svc?.onHelpButtonClick();
  });
}

export function handleIntersection(entry, element) {
  if (entry.isIntersecting) {
    // when the footer becomes visible, show the button
    if (!element.classList.contains('is-footer-visible')) {
      element.classList.add('is-footer-visible');
    }
  } else {
    // when the footer is not visible, hide the button
    element.classList.remove('is-footer-visible');
  }
}

// toggle CSS class to show the button when the footer is in view
// useful examples: https://css-tricks.com/a-few-functional-uses-for-intersection-observer-to-know-when-an-element-is-in-view/
/*
function initializeObserver(buttonExists = false) {
  // the first time the user scrolls to the footer, we should initialize the button
  let isButtonInitialized = buttonExists;
  // we want to toggle the class on the <body> element and use CSS to hide the button
  const bodyElement = document.querySelector('body');
  // we're watching to see if the footer is in view
  const footerElement = document.querySelector('#footer');

  // bail if either element doesn't exist
  if (bodyElement != null && footerElement != null) {
    const options = {
      root: null,
      rootMargin: '0px',
      // set the threshold high enough that the button won't overlap the "Add to Cart" button
      // effectively, the footer is 10% visible, consider it "intersecting"
      threshold: [0.1],
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        handleIntersection(entry, bodyElement);

        // if the button hasn't been initialized yet, do it now
        if (entry.isIntersecting && !isButtonInitialized) {
          initializeButton();
          isButtonInitialized = true;
        }
      });
    }, options);

    // start watching the footer element
    observer.observe(footerElement);
  }
}
*/

/*
function lazyLoadButton() {
  // check whether the screen is small enough for IntersectionObserver to be needed
  const mediaQuery = window.matchMedia('(min-width: 41.5rem)');
  const isSmallScreen = !mediaQuery.matches;

  if (isSmallScreen) {
    // use IntersectionObserver to show/hide the button when needed
    initializeObserver();
  } else {
    // on large screens, we always need the button to be there
    initializeButton();

    // if the window is resized to be small, use IntersectionObserver to
    // show/hide the button when needed
    mediaQuery.addEventListener('change', (event) => {
      if (!event.matches) {
        initializeObserver(true);
      }
    });
  }
}
*/

export function initializeLiveChat() {
  // if (window.IntersectionObserver) {
  //   lazyLoadButton();
  // } else {
  initializeButton();
  // }
}
